import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import React from 'react';
const debug = process.env.REACT_APP_DEBUG && false;
export const TextComponent = (props) => {
    const { matchedPrimary, viewKeyDefinition, updateKV, functionOverrides, textFieldProps } = props;
    debug && console.log('TextComponent props', props);
    //const classes = useStyles(denseTheme);
    const regex = new RegExp(viewKeyDefinition?.validationRx || '');
    const validationError = !regex.test(matchedPrimary[viewKeyDefinition.key]);
    //debug && console.log('Validation res', validationError)
    const inputType = viewKeyDefinition.type;
    const derivedValue = viewKeyDefinition.valueGetter
        ? viewKeyDefinition.valueGetter(matchedPrimary[viewKeyDefinition.key], matchedPrimary)
        : (matchedPrimary[viewKeyDefinition.key] ?? '');
    const keyBase = `${matchedPrimary.sk ?? 'newObject'}_${viewKeyDefinition.key}`;
    debug && console.log('derivedValue', derivedValue);
    return (_jsx(TextField, { InputLabelProps: { shrink: true },
        onChange: (event) => {
            const derivedValue = viewKeyDefinition.valueSetter ? viewKeyDefinition.valueSetter(event.target.value) : event.target.value;
            event.target.value = derivedValue;
            debug &&
                console.log(`on text input change`, {
                    viewKeyDefinition,
                    derivedValue,
                    targetVal: event.target.value,
                });
            updateKV(event, viewKeyDefinition.key);
            if (functionOverrides?.hasValidationErrors) {
                functionOverrides?.hasValidationErrors();
            }
            if (viewKeyDefinition.stateFn) {
                viewKeyDefinition.stateFn(event);
            }
        },
        size: 'small',
        margin: 'dense',
        type: inputType,
        value: derivedValue,
        label: viewKeyDefinition.label,
        error: validationError,
        helperText: validationError && (viewKeyDefinition.failsValidationText ?? 'Fails validation'),
        variant: 'standard',
        disabled: viewKeyDefinition.editable === false,
        ...textFieldProps }, `${keyBase}_fcontrol_tfield`));
};
